import {
  createUserWithEmailAndPassword,
  deleteUser,
  getAuth,
} from "firebase/auth";
import {
  doc,
  getFirestore,
  runTransaction,
  serverTimestamp,
} from "firebase/firestore";
import { ISchemaAdminInfo, IBusinessInfo } from "../../shared/types";

const register = async (
  businessData: IBusinessInfo,
  adminData: ISchemaAdminInfo
) => {
  businessData.date_created = serverTimestamp();
  businessData.phone = businessData.phone.replaceAll(" ", "");
  businessData.stats = {
    total_shops: 0,
    best_performing_shop: "",
    gross_revenue: 0,
    gross_profit: 0,
    total_sales: 0,
  };

  adminData.phone = adminData.phone.replaceAll(" ", "");
  adminData.created_at = serverTimestamp();

  const db = getFirestore();
  const auth = getAuth();

  try {
    const newAdminObj = await createUserWithEmailAndPassword(
      auth,
      adminData.email,
      adminData.password!
    );
    const newAdminRef = doc(db, "users", newAdminObj.user.uid);
    const newBusinessRef = doc(db, "businesses", newAdminObj.user.uid);

    businessData.admin = newAdminRef;
    adminData.associatedBusiness = newBusinessRef;

    await runTransaction(db, async (transaction) => {
      transaction.set(newBusinessRef, businessData).set(newAdminRef, adminData);
    });

    return;
  } catch (error) {
    if (getAuth().currentUser) {
      await deleteUser(getAuth().currentUser!);
    }

    throw error;
  }
};

export default register;
